<template>
  <!-- 对话框 -->
  <el-dialog title="编辑公司信息" :visible.sync="show" width="70%" top="2vh" :before-close="closeDialog">
    <div style="height: 72vh ;overflow-y: auto;">

      <!-- 高德地图 -->
      <div id="container_edit"></div>
      <!-- 高德地图功能组件 -->
      <!-- 基本信息表单 -->
      <div class="form-box">
        <el-form ref="form" :model="submit_data" label-width="80px">
          <el-form-item label="公司名称">
            <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder"></el-input>
          </el-form-item>
          <el-form-item label="公司简称">
            <el-input v-model="submit_data.name_simple" :placeholder="submit_rules.name_simple.placeholder"></el-input>
          </el-form-item>


          <el-form-item label="公司地区" v-show="address_disable">
            <el-cascader :props="props" style="width: 100%;" ref="citySelect" @change="search"></el-cascader>
          </el-form-item>
          <el-form-item label="公司地址">
            <!-- 搜索高德数据 -->
            <el-autocomplete v-model="submit_data.address" :fetch-suggestions="querySearchAsync"
              :placeholder="submit_rules.address.placeholder" style="width:100%" :disabled="!address_disable"
              @select="handleSelect">
              <el-button slot="append" icon="el-icon-edit" :style="editButtonStyle"
                @click="address_disable = !address_disable">{{editButtonName}}</el-button>
            </el-autocomplete>
          </el-form-item>




          <el-form-item label="公司电话">
            <el-input v-model="submit_data.telephone" :placeholder="submit_rules.telephone.placeholder" :maxlength=13>
            </el-input>
          </el-form-item>
          <el-form-item label="公司网址">
            <el-input v-model="submit_data.website" :placeholder="submit_rules.website.placeholder"></el-input>
          </el-form-item>
          <el-form-item label="负责人">
            <el-input v-model="submit_data.boss" :placeholder="submit_rules.boss.placeholder"></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input v-model="submit_data.phone" :placeholder="submit_rules.phone.placeholder" :maxlength=11>
            </el-input>
          </el-form-item>
        </el-form>
        <el-upload class="avatar-uploader" action="http://9z.tiantianapi.com/company/addCompanySubmit"
          :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span>*只能上传尺寸为128×128的jpg/png文件，且不超过10M。</span>
      </div>

    </div>
    <!-- 对话框底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="closeDialog">返回</el-button>
    </span>
  </el-dialog>
</template>

<script>
  var _this, district, map;
  let id = 0;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {
      isShow(newData, oldData) {

        _this.show = true;
        // 将公司唯一编码存到search_data对象中用作向后台发送请求
        _this.search_data.company_code = _this.data;
        // 初始化
        _this.companyInit();

      },



      address_disable(newData, oldData) {

        if (newData == true) {

          _this.old_address = _this.submit_data.address;
          _this.submit_data.address = '';
          _this.editButtonName = "取消";
          _this.editButtonStyle = 'background-color: #999;color:#FFF';

        } else {

          _this.submit_data.address = _this.old_address;
          _this.editButtonName = "编辑";
          _this.editButtonStyle = 'background-color: blue;color:#FFF';

        }

      },
    },

    data() {
      return {
        show: false,

        search_data: {
          company_code: ''
        },
        company_data: '',

        // 编辑地址信息
        address_disable: false,
        editButtonName: "编辑",
        old_address: '',
        editButtonStyle: 'background-color: blue;color:#FFF',

        // 联级lazyload
        props: {
          lazy: true,
          lazyLoad(node, resolve) {
            if (node.level == 1) {
              _this.getData('province', false, node, resolve)
            } else if (node.level == 2) {
              _this.getData('city', true, node, resolve)
            } else {

              var opts = {
                subdistrict: 1, //返回下一级行政区
                showbiz: false //最后一级返回街道信息
              };

              district = new AMap.DistrictSearch(opts); //注意：需要使用插件同步下发功能才能这样直接使用

              district.search('中国', function (status, result) {
                if (status == 'complete') {
                  const nodes = Array.from(result.districtList[0].districtList)
                    .map(item => ({
                      value: item.adcode,
                      label: item.name,
                      leaf: false
                    }));
                  // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                  resolve(nodes);
                }
              });
            }
          }
        },

        //上传图片
        imageUrl: '',
        restaurants: [],

        // 表单数据
        submit_data: {
          name: '',
          company_code: '',
          name_simple: '',
          address: '',
          address_coordinate: '',
          telephone: '',
          website: '',
          boss: '',
          logo_url: '',
          phone: ''
        },

        submit_rules: {
          name: {
            placeholder: '公司名称100字以内',
            rules: {
              required: true,
              message: '角色名10个汉字以下',
              regulation: 'elt_str',
              rulesData: 100
            }
          },
          company_code: {
            placeholder: '公司为一编码',
            rules: {
              required: true,
              message: '角色名10个汉字以下',
              regulation: 'special',
              rulesData: 'company_code'
            }
          },
          name_simple: {
            placeholder: '公司简称30字节之内',
            rules: {
              required: true,
              message: '公司简称30字节之内',
              regulation: 'elt_str',
              rulesData: 30
            }
          },
          address: {
            placeholder: '公司地址',
            rules: {
              required: true,
              message: '公司地址，200字节以内',
              regulation: 'elt_str',
              rulesData: 200
            }
          },
          telephone: {
            placeholder: '座机电话',
            rules: {
              required: false,
              message: '座机电话错误',
              regulation: 'elt_str',
              rulesData: 30
            }
          },
          phone: {
            placeholder: '手机号码必须为11位',
            rules: {
              required: true,
              message: '手机号码必须为11位',
              regulation: 'eq_str',
              rulesData: 11
            }
          },
          website: {
            placeholder: '公司网址',
            rules: {
              required: false,
              message: '',
              regulation: 'lt_str',
              rulesData: 200
            }
          },
          boss: {
            placeholder: '公司负责人30字节以内',
            rules: {
              required: false,
              message: '角色备注说明，200字节以内',
              regulation: 'elt_str',
              rulesData: 30
            }
          },
          logo_url: {
            placeholder: 'logo地址，网址格式',
            rules: {
              required: false,
              message: '角色备注说明，200字节以内',
              regulation: 'lt_str',
              rulesData: 200
            }
          }
        },

        // 下拉列表
        options: [{
          value: '选项1',
          label: '公司名称'
        }, {
          value: '选项2',
          label: '公司简称'
        }],
        value: [],

        //存放联级的地址数据
        address_data: '',
      };
    },
    created() {
      _this = this;

    },
    methods: {
      // 初始化
      companyInit() {
        _this.$post(
          "/company/getCompanyDetails", {
            company_code: _this.search_data.company_code
          }
        ).then(res => {
          // 将获取到的值赋值给submit_data对象
          _this.submit_data.name = res.data.name;
          _this.submit_data.company_code = _this.search_data.company_code;
          _this.submit_data.name_simple = res.data.name_simple;
          _this.submit_data.address = res.data.address;
          _this.submit_data.address_coordinate = res.data.address_coordinate;
          _this.submit_data.telephone = res.data.telephone;
          _this.submit_data.website = res.data.website;
          _this.submit_data.boss = res.data.boss;
          _this.submit_data.logo_url = res.data.logo_url;
          _this.submit_data.phone = res.data.phone;

          // 将获取的地图中心点转换为数组格式
          var center = _this.submit_data.address_coordinate.split(',')
          // 设置地图级别和中心点
          map.setZoomAndCenter(20, center);
        }).catch((err) => {


        })

        setTimeout(() => {

          // 地图初始化
          map = new AMap.Map('container_edit', {
            //初始化地图中心点
            center: [114.493773, 38.016561],
            resizeEnable: true, //是否监控地图容器尺寸变化
            zoom: 11, //初始地图级别
          });

        }, 1);
        _this.querySearchAsync()
      },
      // 提交
      onSubmit() {

        console.log(_this.submit_data);


        _this.$post(
            "/company/editCompanySubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit')
            this.$message.success(res.msg);
            _this.closeDialog();
          })
      },
      closeDialog() {
        _this.show = false;
        _this.address_disable = false;

        // 关闭时清空级联选择器的显示内容
        _this.$refs['citySelect'].inputValue = '';


      },
      getData(level, boo, node, resolve) {
        //将联级内容加入submit_data对象
        _this.address_data += node.data.label

        //adcode
        var adcode = node.data.value;

        district.setLevel(level); //行政区级别

        district.setExtensions('all');

        //按照adcode进行查询可以保证数据返回的唯一性
        district.search(adcode, function (status, result) {
          if (status === 'complete') {
            const nodes = Array.from(result.districtList[0].districtList)
              .map(item => ({
                value: item.adcode,
                label: item.name,
                leaf: boo
              }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        });
      },

      search(val) {
        district.search(val[2], function (status, result) {
          //将联级内容加入submit_data对象

          _this.address_data += result.districtList[0].name
          _this.submit_data.address = _this.address_data,
            _this.address_data = '';
          map.setZoomAndCenter(20, [result.districtList[0].center.lng, result.districtList[0].center.lat]);
        });
      },

      querySearchAsync(queryString, cb) {
        //为空的时候不搜索
        if (typeof (queryString) == 'undefined' || queryString.length == 0) {
          return;
        }
        //判断城市是否已选择，否者提醒选择城市
        if (_this.$refs['citySelect'].inputValue == null || _this.$refs['citySelect'].inputValue == undefined) {
          //  弹出提示框
          _this.$message('请先选择城市');
          return false;
        }
        var restaurants = _this.restaurants;
        AMap.plugin('AMap.Autocomplete', function () {
          // 实例化Autocomplete
          var autoOptions = {
            // 城市级联的值
            city: _this.$refs['citySelect'].checkedValue[1]
          }
          var autoComplete = new AMap.Autocomplete(autoOptions);
          autoComplete.search(queryString, function (status, result) {
            if (typeof (result.tips) == 'undefined') {
              return;
            }
            // 搜索成功时，result即是对应的匹配数据

            if (result.tips) {
              for (let i = 0; i < result.tips.length; i++) {
                restaurants[i] = {
                  "value": result.tips[i].name,
                  "address": result.tips[i].location
                };
              }
              var results = queryString ? restaurants.filter(_this.createStateFilter(queryString)) :
                restaurants;
              cb(results);
            }
            if (typeof (result.tips[0].location) == 'undefined' || result.tips[0].location == '' || result.tips[
                0].location.length == 0) {
              //什么也不做
            } else {
              // 将坐标信息转换为字符串类型添加到 submit_data对象中
              _this.submit_data.address_coordinate = parseFloat(result.tips[0].location.lng) + "," + parseFloat(
                result.tips[0].location.lat)
              // 修改地图坐标
              map.setZoomAndCenter(20, [result.tips[0].location.lng, result.tips[0].location.lat]);
              return;
            }
            if (typeof (result.tips[1].location) == 'undefined' || result.tips[1].location == '' || result.tips[
                1].location.length == 0) {
              //什么也不做
            } else {
              // 将坐标信息转换为字符串类型添加到 submit_data对象中
              _this.submit_data.address_coordinate = parseFloat(result.tips[1].location.lng) + "," + parseFloat(
                result.tips[1].location.lat)
              // 修改地图坐标
              map.setZoomAndCenter(20, [result.tips[1].location.lng, result.tips[1].location.lat]);
              return;
            }
            return;
          });
        })
      },

      createStateFilter(queryString) {
        return (state) => {
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },

      handleSelect(item) {
        if (typeof (item.address.lng) !== 'undefined') {
          // 将坐标信息转换为字符串类型添加到 submit_data对象中
          _this.submit_data.address_coordinate = parseFloat(item.address.lng) + "," + parseFloat(item.address.lat)
          return;
        }
        return;
      },

      // 上传图片
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        // 将图片的路径存到submit_data对象中
        _this.submit_data.logo_url = this.imageUrl
      },

      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt10M = file.size / 1024 / 1024 < 10;
        // 如果图片不是jpg和png格式
        if (!isJPG && !isPNG) {
          // 弹出提示窗口
          this.$message.error('上传头像图片只能是 JPG 格式!');
        } else {
          // 不进行操作
          console.log('格式正确');
        }
        // 判断文件大小
        if (!isLt10M) {
          this.$message.error('上传头像图片尺寸必须为128*128且大小不能超过 10MB!');
        } else {
          const isSize = new Promise((resolve, reject) => {
            const width = 128;
            const height = 128;
            const _URL = window.URL || window.webkitURL;
            const img = new Image();
            img.onload = () => {
              const valid = img.width >= width && img.height >= height && img.width === img.height;
              valid ? resolve() : reject();
            };
            img.src = _URL.createObjectURL(file);
          }).then(
            () => {
              return file;
            },
            () => {
              this.$message.error('图片尺寸限制为128*128，大小不可超过10MB');
              return Promise.reject();
            },
          );
          return isSize;
        }
        return isJPG && isLt10M;
      },
    }
  };
</script>

<style scoped>
  /* 高德地图css */
  @import 'https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css';
  @import 'https://a.amap.com/jsapi_demos/static/demo-center/css/prety-json.css';

  #container_edit {
    height: 90%;
    width: 65%;
    float: left;
  }

  .form-box {
    width: 35%;
    padding: 20px;
    box-sizing: border-box;
    float: left;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
</style>